import { render, staticRenderFns } from "./WorkspaceProjects.vue?vue&type=template&id=503a53f2&scoped=true"
import script from "./WorkspaceProjects.vue?vue&type=script&lang=js"
export * from "./WorkspaceProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a53f2",
  null
  
)

export default component.exports